import script from "./UpdatePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=5437ef0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5437ef0f"]])

export default __exports__